.card {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  border: 1px solid var(--alert-share-export-card-border);
  border-radius: 12px;
}

.cardLeft {
  display: flex;
  flex: 1;
  gap: 1rem;
  align-items: center;
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
}

.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 8px;
}

.iconContainerPurple {
  background: var(--alert-share-export-card-icon-container-purple-background);
  border: 1px solid var(--alert-share-export-card-icon-container-purple-border);
}

.iconContainerBlue {
  background: var(--alert-share-export-card-icon-container-blue-background);
  border: 1px solid var(--alert-share-export-card-icon-container-blue-border);
}

.icon {
  width: 1.75rem;
  height: 1.75rem;
}

.cardRight {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.arrow {
  width: 1.5rem;
  height: 1.5rem;
}
